import CryptoJS from "crypto-js";
import config from "../config";
import api from "../api";
import global from "../components/Global.vue";

const utils = {
  sType: new Map(),
  sTypeIcon: new Map(),
  categoryList: new Map(),
  getRC4Hex(message, key) {
    var keys = CryptoJS.enc.Utf8.parse(key);
    //        加密
    var encode = CryptoJS.RC4.encrypt(message, keys);
    //        默认tostring就是to hex
    var base64code = CryptoJS.enc.Base64.parse(encode.toString());

    var encryptedHexStr = CryptoJS.enc.Hex.stringify(base64code);

    var hexsStr = encryptedHexStr.toString(CryptoJS.enc.Utf8);

    return hexsStr;
  },
  stringToByte(str) {
    var bytes = [];
    var len, c;
    len = str.length;
    for (var i = 0; i < len; i++) {
      c = str.charCodeAt(i);
      if (c >= 0x010000 && c <= 0x10ffff) {
        bytes.push(((c >> 18) & 0x07) | 0xf0);
        bytes.push(((c >> 12) & 0x3f) | 0x80);
        bytes.push(((c >> 6) & 0x3f) | 0x80);
        bytes.push((c & 0x3f) | 0x80);
      } else if (c >= 0x000800 && c <= 0x00ffff) {
        bytes.push(((c >> 12) & 0x0f) | 0xe0);
        bytes.push(((c >> 6) & 0x3f) | 0x80);
        bytes.push((c & 0x3f) | 0x80);
      } else if (c >= 0x000080 && c <= 0x0007ff) {
        bytes.push(((c >> 6) & 0x1f) | 0xc0);
        bytes.push((c & 0x3f) | 0x80);
      } else {
        bytes.push(c & 0xff);
      }
    }
    return bytes;
  },
  hextoString(hex) {
    var arr = hex.split("");
    var out = "";
    for (var i = 0; i < arr.length / 2; i++) {
      var tmp = "0x" + arr[i * 2] + arr[i * 2 + 1];
      var charValue = String.fromCharCode(tmp);
      out += charValue;
    }
    return out;
  },
  stringtoHex(str) {
    var hextable = "0123456789abcdef";
    var strbyte = this.stringToByte(str);
    var dst = [];
    for (var i = 0; i < strbyte.length; i++) {
      dst[i * 2] = hextable[strbyte[i] >> 4];
      dst[i * 2 + 1] = hextable[strbyte[i] & 0x0f];
    }
    var result = "";
    for (let index = 0; index < dst.length; index++) {
      result = result + dst[index];
    }
    return result;
  },
  getDecodeRC4Hex(encrypted, key) {
    //        解密
    //        这个必须要有
    var keys = CryptoJS.enc.Utf8.parse(key);
    //        hex解密
    var encryptedHexStr = CryptoJS.enc.Hex.parse(encrypted);
    //        转成base64字符串
    var srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    //        rc4解密
    var decrypteds = CryptoJS.RC4.decrypt(srcs, keys);

    return decrypteds.toString(CryptoJS.enc.Utf8);
  },
  showMsg(messge) {
    alert(messge);
  },
  goUri(apiUrl) {
    window.location.href = apiUrl;
  },
  log(message) {
    console.log(message);
  },
  checkIsNeedToGoBurg(to) {
    return (
      to.query.appid === config.burgAppid &&
      (to.path === "/agent" ||
        to.path === "/device" ||
        to.path === "/accessory" ||
        to.path === "/deviceuser" ||
        to.path === "/aboutdevice" ||
        to.path === "/parametersetting" ||
        to.path === "/feedback" ||
        to.path === "/eventlist" ||
        to.path === "/problemdevicelist")
    );
  },
  checkIsNeedToGoCN(to) {
    return (
      to.query.appid === config.cnAppid &&
      (to.path === "/agent" ||
        to.path === "/device" ||
        to.path === "/accessory" ||
        to.path === "/deviceuser" ||
        to.path === "/aboutdevice" ||
        to.path === "/parametersetting" ||
        to.path === "/feedback" ||
        to.path === "/eventlist" ||
        to.path === "/problemdevicelist")
    );
  },
  checkIsNeedToGoBlackhole(to) {
    return !utils.checkIsNeedToGoBurg(to) && !utils.checkIsNeedToGoCN(to);
  },
  login(username, password, callback) {
    var params = new URLSearchParams();
    var jsons = {
      uid: username,
      password: password
    };
    params.append(
      "json",
      this.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET)
    );
    api.request("post", "/login?_type=json", params).then(response => {
      var data = response.data;
      if (data.Status !== 1) {
        callback(false, "");
        return;
      }

      /* Setting user in the state and caching record to the localStorage */
      if (data.Result) {
        var decodeResult = this.getDecodeRC4Hex(data.Result, global.APP_SECRET);
        //              返回的数据有双引号，需要转两次json，才可以
        var myJson = JSON.parse(decodeResult);
        myJson.pw = this.getRC4Hex(myJson.pw, global.APP_SECRET);
        callback(true, myJson);
      }
    });
  },
  checkIsSuperAdmin() {
    if (window.localStorage) {
      var localUserString = window.localStorage.getItem("user") || "null";
      var localUser = JSON.parse(localUserString);

      if (localUser.pm > 888) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  checkIsAdmin() {
    if (window.localStorage) {
      var localUserString = window.localStorage.getItem("user") || "null";
      var localUser = JSON.parse(localUserString);

      if (localUser.pm >= 888) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  checkIsAppSuperAdmin() {
    if (window.localStorage) {
      var localUser = window.localStorage.getItem("appper") || "null";

      if (localUser > 888) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  checkIsAppAdmin() {
    if (window.localStorage) {
      var localUser = window.localStorage.getItem("appper") || "null";
      if (localUser >= 888) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  checkIsNeedToLogin(to) {
    if (this.isEmpty(to.query.u) || this.isEmpty(to.query.p)) {
      return false;
    }
    return true;
  },
  formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    }
    let o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds()
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + "";
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? str : this.padLeftZero(str)
        );
      }
    }
    return fmt;
  },
  padLeftZero(str) {
    return ("00" + str).substr(str.length);
  },
  getRandomString(length) {
    var str = "";
    for (
      ;
      str.length < length;
      str += Math.random()
        .toString(36)
        .substr(2)
    );
    return str.substr(0, length);
  },
  getMessageId() {
    return this.getRandomString(12);
  },
  isHasKey(target, key) {
    return target.hasOwnProperty(key);
  },
  isEmpty(target) {
    if (!target) {
      return true;
    }
    return false;
  },
  checkIsURL(url) {
    return /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/.test(
      url
    );
  },
  initPluginDataMap() {
    var m = new Map();
    m.set("13", "Smart Light");
    m.set("14", "Wireless Siren");
    m.set("15", "Smart Plug");
    m.set("17", "Distance Sensor");
    m.set("19", "Window Sensor");
    m.set("1B", "Wireless Keypad");
    m.set("1F", "IP Camera");
    m.set("0B", "Door Window Sensor");
    m.set("09", "PIR Sensor");
    m.set("0A", "Gas Sensor");
    m.set("05", "Smoke Sensor");
    m.set("02", "Remote Controller");
    m.set("08", "Remote Controller");
    m.set("01", "Remote Controller");
    m.set("04", "Remote Controller");
    m.set("07", "Panic Button");
    m.set("30", "Panic Button");
    m.set("0D", "Remote Controller");
    m.set("0E", "Liquid Sensor");
    m.set("06", "Vibration Sensor");
    m.set("CC", "Vibration Sensor");
    m.set("31", "CO Detector");
    m.set("32", "Outdoor PIR");
    m.set("33", "Outdoor Beam");
    m.set("37", "RFID Tag");
    this.sType = m;

    var im = new Map();
    im.set("13", "../../../static/img/accessoryicon/icon_eventlist_others.svg");
    im.set(
      "14",
      "../../../static/img/accessoryicon/icon_eventlist_wireless_siren.svg"
    );
    im.set("15", "../../../static/img/accessoryicon/icon_eventlist_switch.svg");
    im.set("17", "../../../static/img/accessoryicon/icon_eventlist_others.svg");
    im.set(
      "19",
      "../../../static/img/accessoryicon/icon_eventlist_doorwindow_sensor.svg"
    );
    im.set("1B", "../../../static/img/accessoryicon/icon_eventlist_keypad.svg");
    im.set("1F", "../../../static/img/accessoryicon/icon_eventlist_ipc.svg");
    im.set(
      "0B",
      "../../../static/img/accessoryicon/icon_eventlist_doorwindow_sensor.svg"
    );
    im.set("09", "../../../static/img/accessoryicon/icon_eventlist_pir.svg");
    im.set(
      "0A",
      "../../../static/img/accessoryicon/icon_eventlist_gas_sensor.svg"
    );
    im.set(
      "05",
      "../../../static/img/accessoryicon/icon_eventlist_smoke_sensor.svg"
    );
    im.set(
      "02",
      "../../../static/img/accessoryicon/icon_eventlist_remote_control.svg"
    );
    im.set(
      "08",
      "../../../static/img/accessoryicon/icon_eventlist_remote_control.svg"
    );
    im.set(
      "01",
      "../../../static/img/accessoryicon/icon_eventlist_remote_control.svg"
    );
    im.set(
      "04",
      "../../../static/img/accessoryicon/icon_eventlist_remote_control.svg"
    );
    im.set(
      "07",
      "../../../static/img/accessoryicon/icon_eventlist_urgentbtn_sensor.svg"
    );
    im.set(
      "30",
      "../../../static/img/accessoryicon/icon_eventlist_urgentbtn_sensor.svg"
    );
    im.set(
      "0D",
      "../../../static/img/accessoryicon/icon_eventlist_remote_control.svg"
    );
    im.set(
      "0E",
      "../../../static/img/accessoryicon/icon_eventlist_water_sensor.svg"
    );
    im.set(
      "06",
      "../../../static/img/accessoryicon/icon_eventlist_shake_sensor.svg"
    );
    im.set(
      "CC",
      "../../../static/img/accessoryicon/icon_eventlist_shake_sensor.svg"
    );
    im.set(
      "31",
      "../../../static/img/accessoryicon/icon_eventlist_cosensor.svg"
    );
    im.set("32", "../../../static/img/accessoryicon/icon_eventlist_pir.svg");
    im.set("33", "../../../static/img/accessoryicon/icon_eventlist_others.svg");
    im.set("37", "../../../static/img/accessoryicon/icon_eventlist_rfid.svg");
    this.sTypeIcon = im;

    this.categoryList = new Map();
    this.categoryList.set("0B", 0);
    this.categoryList.set("09", 0);
    this.categoryList.set("05", 0);
    this.categoryList.set("07", 0);
    this.categoryList.set("02", 1);
    this.categoryList.set("14", 4);
    this.categoryList.set("1B", 1);
    this.categoryList.set("0E", 0);
    this.categoryList.set("06", 0);
    this.categoryList.set("15", 3);
    this.categoryList.set("37", 1);
  },
  getNameByCatAndSub(cat, sub) {
    if (cat === 10) {
      if (sub === "17") {
        return this.sType.get("09");
      } else if (sub === "16") {
        return this.sType.get("0B");
      } else if (sub === "18") {
        return this.sType.get("0E");
      } else if (sub === "19") {
        return this.sType.get("06");
      } else if (sub === "21") {
        return this.sType.get("14");
      } else if (sub === "22") {
        return this.sType.get("14");
      } else if (sub === "11") {
        return this.sType.get("0B");
      }
    }
    return this.sType.get(sub);
  },
  getPluginIconByCatAndSub(cat, sub) {
    if (cat === 10) {
      if (sub === "17") {
        return this.sTypeIcon.get("09");
      } else if (sub === "16") {
        return this.sTypeIcon.get("0B");
      } else if (sub === "18") {
        return this.sTypeIcon.get("0E");
      } else if (sub === "19") {
        return this.sTypeIcon.get("06");
      } else if (sub === "21") {
        return this.sTypeIcon.get("14");
      } else if (sub === "22") {
        return this.sTypeIcon.get("14");
      } else if (sub === "11") {
        return this.sTypeIcon.get("0B");
      }
    }
    return this.sTypeIcon.get(sub);
  },
  getCategory(sub) {
    return this.categoryList.get(sub);
  },

  capitalize(str) {
    return str
      .toLowerCase()
      .replace(/(^\w)|(_\w)/g, match => match.toUpperCase())
      .replace(/_+/g, " ");
  }
};

export default utils;



// WEBPACK FOOTER //
// ./src/utils/index.js